/* eslint-disable no-undef */
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import MenuBarHome from '../../components/Home/MenuBar/MenuBarHome';
import MenuProfile from '../../components/MenuProfile/MenuProfile';
import { ContainerPages } from '../../components/Containers';
import { SearchCompanyAction } from '../../redux/actions/company';
import TemplateAdminUserEdit from '../../templates/User/AdminEdit';
import LogoBackground from '../../components/LogoBackground';

export default function UserEditAdmin(props) {
  const userId = props.match.params.id;
  const { userInfo } = useSelector((state) => state.userSign);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(SearchCompanyAction());
  }, [dispatch]);

  useEffect(() => {
    if (!userInfo) {
      props.history.push('/login');
    }
    if (userInfo !== null) {
      if (
        userInfo.accessMode === process.env.REACT_APP_DEV_ACCESS ||
        userInfo.accessMode === process.env.REACT_APP_SUPORTE_SINCRONIZA_ACCESS ||
        userInfo.accessMode === process.env.REACT_APP_ADMIN_SPA_ACCESS
      ) {
        props.history.push(`/editar-usuario/${userId}`);
      } else {
        props.history.push('/login');
      }
    }
  }, [userInfo, props.history, userId]);

  return (
    <ContainerPages>
      <MenuProfile />
      <MenuBarHome />
      <TemplateAdminUserEdit userId={userId} />
      <LogoBackground />
    </ContainerPages>
  );
}
